import { useNavigate } from "react-router-dom";

import Style from "./style";

import MainHeader from "widget/MainHeader";
import Search from "widget/Search"
import Pagenation from "widget/Pagenation";

import TStyle from "shared/style/tableStyle";
import TableLoading from "shared/ui/TableLoading"
import useGetSeedTicketStatus from "entity/ticket/useGetSeedTicketStatus";

/**
 * @Desc 시드권 현황 Page
 * @Access 없음
 *
 */
const SeedTicketStatus = () => {
  const navigate = useNavigate();
  const [seedTicketStatusList, isLoading] = useGetSeedTicketStatus()

  const sizeList = ["short", "expand", "long", "expand", "medium"]
  const tableHeadList = [
    { label: "ID", sortKey: "accountid" },
    { label: "이름", sortKey: "accountname" },
    { label: "연락처", sortKey: "accountcontact" },
    { label: "시드권 타입", sortKey: "tickettype" },
    { label: "보유 개수", sortKey: "ticketcount" },
  ]

  return (
    <Style.Wrapper>
      <MainHeader>시드권 현황</MainHeader>
      <Search 
        placeholder="연락처 또는 이름을 입력해주세요"
        ticketTypeIdxFilter={true}
      />

      <TableLoading isLoading={isLoading}>
        <TStyle.TableDiv>
          <TStyle.TableInner>
            <TStyle.TableRow $title>
              {tableHeadList.map((elem, index) => (
                <TStyle.Data key={index} $title $size={sizeList[index]}>
                  {elem.label}
                </TStyle.Data>
              ))}
            </TStyle.TableRow>
            {seedTicketStatusList?.data?.items?.map((seed, index) => {
              return (
                <TStyle.TableRow
                  key={index}
                  $odd={index % 2 === 1}
                  onClick={() => navigate(`/user/${seed?.accountid}/detail`)}
                >
                  <TStyle.Data $size={sizeList[0]}>{seed?.accountid}</TStyle.Data>
                  <TStyle.Data $size={sizeList[1]}>
                    {seed?.accountname}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[2]}>
                    {seed?.accountcontact}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[3]}>
                    {seed?.tickettype}
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[4]}>
                    {seed?.ticketcount}
                  </TStyle.Data>
                </TStyle.TableRow>
              );
            })}
          </TStyle.TableInner>
        </TStyle.TableDiv>
      </TableLoading>

      <Pagenation maxPage={seedTicketStatusList?.data?.max_page} />
    </Style.Wrapper>
  );
};

export default SeedTicketStatus;
